/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { BillingPricingProduct } from './BillingPricingProduct';
// @ts-ignore
import {
// @ts-ignore
    BillingPricingProductFromJSON,
// @ts-ignore
    BillingPricingProductFromJSONTyped,
// @ts-ignore
    BillingPricingProductToJSON,
} from './BillingPricingProduct';

/**
 * 
 * @export
 * @interface BillingPricingOption
 */
export interface BillingPricingOption {
    /**
     * 
     * @type {string}
     * @memberof BillingPricingOption
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof BillingPricingOption
     */
    currencyCode: string;
    /**
     * 
     * @type {Array<BillingPricingProduct>}
     * @memberof BillingPricingOption
     */
    products: Array<BillingPricingProduct>;
}

/**
 * Check if a given object implements the BillingPricingOption interface.
 */
// @ts-ignore
export function instanceOfBillingPricingOption(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "countryCode" in value;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "products" in value;

    return isInstance;
}

// @ts-ignore
export function BillingPricingOptionFromJSON(json: any): BillingPricingOption {
    return BillingPricingOptionFromJSONTyped(json, false);
}

// @ts-ignore
export function BillingPricingOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingPricingOption {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'countryCode': json['country_code'],
        'currencyCode': json['currency_code'],
        'products': ((json['products'] as Array<any>).map(BillingPricingProductFromJSON)),
    };
}

// @ts-ignore
export function BillingPricingOptionToJSON(value?: BillingPricingOption | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'country_code': value.countryCode,
        'currency_code': value.currencyCode,
        'products': ((value.products as Array<any>).map(BillingPricingProductToJSON)),
    };
}

